/* eslint-disable max-len */
import * as React from "react";
import { connect } from "react-redux";
import { FillUp } from "@vwpfs/mary-air-lib/components/air/04-helpers/FillUp";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { ProductTariffRequests } from "../../../../../store/Product/Types";
import { ReduxState, isRemoteLoading } from "../../../../../store/ReduxState";
import { remoteTrigger } from "../../../../../store/RemoteActions";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { Tariffs } from "../../../../../store/Tariffs/Types";
import { ThemeBreakpoints, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalClose } from "../../../../../utils/redux/ActionTypes";
import { Results } from "../../00-blocks/Tariffs/ResultsCreateProduct";
import { FlexColumn } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Column";
import { FlexRow } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Row";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { LoadingIndications, LoadingIndicator } from "@vwpfs/mary-air-lib/components/air/05-atoms/LoadingIndicator";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { NavbarStack, NavbarStackContent, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
import { NavbarIcon } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Icon";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";

/**
 *
 */
interface OwnProps {
    modalID: string;
    edit?: boolean;
    productTariffId?: number;
    index: number;
    onChange: <K extends keyof ProductTariffRequests>(key: K, value: ProductTariffRequests[K], index: number) => void;
}

interface StateProps {
    resultsTariffs?: Tariffs;
    remoteLoading: boolean;
}

/**
 *
 */
interface DispatchProps {
    closeModal: (id: string) => void;
    loadTariffResults: (skip: number) => void;
}

/**
 *
 */
type Props = OwnProps & DispatchProps & StateProps;

/**
 *
 * @param s
 */
export const mapStateToProps = (s: ReduxState): StateProps => ({
    resultsTariffs: s.prop("remote").prop(RemoteScope.TARIFF_RESULTS),
    remoteLoading: isRemoteLoading(s, RemoteScope.TARIFF_RESULTS),
});

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    closeModal: (id: string) => {
        dispatch(modalClose(id));
    },
    loadTariffResults: (skip: number) => dispatch(remoteTrigger(RemoteScope.TARIFF_RESULTS, {
        skip: skip,
    })),
});

/**
 *
 */
export class SelectTariffModalComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
        this.closeModal = this.closeModal.bind(this);
    }

    public componentDidMount() {
        this.props.loadTariffResults(0);
    }
    /**
     *
     */
    public render() {
        return (
            <FlexColumn
            >
                <FlexRow isFixed>
                    <Navbar
                        theme={{
                            palette: ThemePalette.BRAND_ACCENT,
                        }}
                    >
                        <NavbarStack>
                            <NavbarStackContent>
                                <NavbarTitle>
                                    Select a tariff
                                </NavbarTitle>
                            </NavbarStackContent>
                            <NavbarStackRight>
                                <NavbarIcon>
                                    <Button icon={IconNames.TIMES}
                                        link={{ onClick: this.closeModal() }} />
                                </NavbarIcon>
                            </NavbarStackRight>
                        </NavbarStack>
                    </Navbar>
                </FlexRow>
                <FlexRow
                    theme={{
                        palette: ThemePalette.CONTRAST_PRIMARY,
                    }}
                >
                    <FlexColumn
                        style={{
                            maxHeight: "calc(90vh - 120px)",
                        }}
                    >
                        <FlexRow isScrollable >
                            {this.props.remoteLoading && !this.props.resultsTariffs
                                ? (
                                    <FillUp>
                                        <Container
                                            theme={{
                                                padding: {
                                                    "": { y: 3 },
                                                    "md": { y: 4 },
                                                },
                                            }}
                                        >
                                            <LoadingIndicator
                                                type={LoadingIndications.DEFAULT}
                                                theme={{ palette: ThemePalette.BRAND_PRIMARY }}
                                            />
                                        </Container>
                                    </FillUp>
                                )
                                : !!this.props.resultsTariffs && (
                                    <FlexColumn>
                                        <Results
                                            results={this.props.resultsTariffs}
                                            onChange={this.props.onChange}
                                            index={this.props.index}
                                            edit={this.props.edit}
                                            productTariffId={this.props.productTariffId}
                                        />
                                    </FlexColumn>)}
                        </FlexRow>
                        <FlexRow isFixed>
                            <FlexColumn
                                theme={{
                                    palette: ThemePalette.CONTRAST_TERTIARY,
                                }}
                            >
                                <Container
                                    theme={{
                                        padding: { "": { y: 3 } },
                                    }}
                                >
                                    <ButtonsWrapper
                                        defaultOrientation={Orientation.HORIZONTAL}
                                        orientations={{
                                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                                        }}
                                        alignment={Alignment.RIGHT}
                                    >
                                        <Button
                                            theme={{ palette: ThemePalette.BRAND_ACCENT }}
                                            link={{ onClick: this.closeModal() }}
                                        >
                                            Continue
                                        </Button>
                                    </ButtonsWrapper>
                                </Container>
                            </FlexColumn>
                        </FlexRow>
                    </FlexColumn>
                </FlexRow>
            </FlexColumn>
        );
    }

    private closeModal() {
        return () => this.props.closeModal(this.props.modalID);
    }
}

/**
 *
 */
export const SelectTariffModal = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectTariffModalComp);
